import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
const Home = () => import('./views/Home.vue')
const SelecionarPerfil = () => import('./views/login/SelecionarPerfil.vue')
const UserAuthentication = () => import('./views/login/UserAuthentication.vue')
const RecuperarSenha = () => import('./views/login/RecuperarSenha.vue')
const RedefinirSenha = () => import('./views/login/RedefinirSenha.vue')
const ResultadoExame = () => import('./views/ResultadoExame.vue')
const RecuperarRegistro = () => import('./views/login/RecuperarRegistro.vue')
const EditarPerfil = () => import('./views/EditarPerfil.vue')
const Atestado = () => import('./views/Atestado.vue')
const Agenda = () => import('./views/Agenda.vue')
const Documentos = () => import('./views/Documentos.vue')
const MedicalReport = () => import('./views/MedicalReport.vue')
const Cirurgias = () => import('./views/cirurgias/Cirurgias.vue')
const CirurgiasFaleConosco = () => import('./views/cirurgias/FaleConosco.vue')
const SolicitacaoReceita = () => import ('./views/SolicitacaoReceita.vue')

Vue.use(Router)
Vue.use(VueCookies)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'UserAuthentication',
      component: UserAuthentication,
      props: (route) => ({ query: route.query.Code }),
      meta: { isPublic: true },
      query: { returnUrl: '' }
    },
    {
      path: '/inicio',
      name: 'Home',
      component: Home,
      meta: { isPublic: false }
    },
    {
      path: '/agenda',
      name: 'Agenda',
      component: Agenda
    },
    {
      path: '/documentos',
      name: 'Documentos',
      component: Documentos,
      meta: { isPublic: false }
    },
    {
      path: '/selecionar-paciente',
      name: 'SelecionarPerfil',
      component: SelecionarPerfil,
      meta: { isPublic: false },
      query: { returnUrl: '' }
    },
    {
      path: '/recuperacao-de-senha',
      name: 'RecuperarSenha',
      component: RecuperarSenha,
      props: route => ({ primeiroAcesso: route.query.primeiroAcesso ? route.query.primeiroAcesso === 'true' : false }),
      meta: { isPublic: true }
    },
    {
      path: '/redefinicao-de-senha',
      name: 'RedefinirSenha',
      component: RedefinirSenha,
      props: (route) => ({ query: route.query.Code }),
      meta: { isPublic: true }
    },
    {
      path: '/recuperar-registro',
      name: 'RecuperarRegistro',
      component: RecuperarRegistro,
      meta: { isPublic: true }
    },
    {
      path: '/resultado-de-exame',
      name: 'ResultadoExame',
      component: ResultadoExame,
      meta: { isPublic: false }
    },
    {
      path: '/editar-perfil',
      name: 'EditarPerfil',
      component: EditarPerfil,
      meta: { isPublic: false }
    },
    {
      path: '/atestado',
      name: 'Atestado',
      component: Atestado,
      meta: { isPublic: false, layout: 'form' }
    },
    {
      path: '/laudos-e-relatorios',
      name: 'MedicalReport',
      component: MedicalReport,
      meta: { isPublic: false, layout: 'form' }
    },
    {
      path: '/cirurgias',
      name: 'Cirurgias',
      component: Cirurgias,
      meta: { isPublic: false }
    },
    {
      path: '/faleconosco-cirurgias',
      name: 'FaleConoscoCirurgias',
      component: CirurgiasFaleConosco,
      props: true,
      meta: { isPublic: false, layout: 'form' }
    },
    {
      path: '/solicitacaoReceita',
      name: 'SolicitacaoReceita',
      component: SolicitacaoReceita,
      meta: { isPublic: false, layout: 'form' }
    },
    // {
    //   path: '/criar-senha',
    //   name: 'CreatePassword',
    //   component: CreatePassword,
    //   meta: { isPublic: true }
    // },
    // otherwise redirect to home
    { path: '*', redirect: { name: 'UserAuthentication' } }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (window.innerWidth > 767 || to.name === 'Home') {
      return { x: 0, y: 0 }
    }

    return {
      selector: '.hero-body .title',
      offset: { x: 0, y: 100 },
      behavior: 'smooth'
    }
  }
})

router.beforeEach((to, from, next) => {
  const { isPublic } = to.meta

  // if the meta route is not public
  if (!isPublic) {
    // if user is authenticated
    if (Vue.$cookies.isKey(process.env.VUE_APP_AUTH_COOKIE)) {
      return next()
    } else {
      return next({ name: 'UserAuthentication', query: { returnUrl: to.path } })
    }
  }

  next()
})

export default router
